import script from "./BackToProjectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToProjectButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackToProjectButton.vue?vue&type=style&index=0&id=66c13a45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c13a45"]])

export default __exports__